import React, { useEffect, useState } from "react";
import moment from "moment";
import BigCarImage from "assets/images/big-list-car.png";
import FleetCarImage from "assets/icons/FilterIcon/filter-icon-1.png";
import MarshalCarImage from "assets/icons/FilterIcon/filter-icon-3.png";
import SpecialNeedCarImage from "assets/icons/FilterIcon/filter-icon-2.png";
import BewrageCarsImage from "assets/icons/FilterIcon/filter-icon-4.png";
import NotInUseCarImage from "assets/icons/FilterIcon/filter-icon-5.png";
import NotCommunicatingCarsImage from "assets/icons/FilterIcon/filter-icon-6.png";
import { useHookstate } from "@hookstate/core";
import ChatIcon from "assets/icons/chat-icon.png";

import SignalIcon from "assets/svgIcons/SignalIcon";
import BatteryIcon from "assets/svgIcons/BatteryIcon";
import BatteryWithPowerIcon from "assets/svgIcons/BatteryWithPowerIcon";
import { CarDetails } from "commonComponents/CarDetails";
import SmallCarIcon from "assets/icons/small-car.png";
import MarshalsCarIcon from "assets/svgIcons/CarType/Marshals";
import FBIcon from "assets/svgIcons/CarType/F&B";
import SpecialNeedCarIcon from "assets/svgIcons/CarType/SpecialNeeds";
import { useTranslation } from "react-i18next";

import {
  MAP_GLOBAL_STATES,
  CAR_NUMBER_MESSAGE,
  FLEET_GLOBAL_STATES,
} from "globalStore/globalStore";

import {
  CardWrapper,
  CarSection,
  InfoSection,
} from "pages/Map/CarList/CarInfoCard/CarInfoCardStyled";
import { Tooltip } from "@mui/material";

const CarInfoCard = ({ car }) => {
  const { t } = useTranslation();
  const { showMessageBoxForSingleCar } = useHookstate(MAP_GLOBAL_STATES);

  const { setCarNumber, carsGpsSelectorData, carsForMessagesGetter } = useHookstate(CAR_NUMBER_MESSAGE);
  const { playerNameData1, playerNameData2 } = useHookstate(FLEET_GLOBAL_STATES);

  const setCarsData = (e, GpsiCarId, carNumber) => {
    e.stopPropagation(e);
    carsGpsSelectorData.set([GpsiCarId]);
    carsForMessagesGetter.set([carNumber]);
    showMessageBoxForSingleCar.set(true);
    setCarNumber.set(carNumber);
  };
  const wifi = car.Car.LastWiFiInUtc;
  const batteryLevel = car.Car.BatteryLevel;
  const carType = car.Car.CarType;
  const inPace = car.Car.PaceStatus;
  const carNo = car.Car.CarNumber;
  const carId = car.Car.GpsiCarId;
  const charging = car.Car.IsCharging;

  useEffect(() => {
    playerNameData1.set(car?.Car?.PlayerName1);
    playerNameData2.set(car?.Car?.PlayerName2);
  }, []);

  const [isWifi, setIsWifi] = useState(wifi);
  const [isShownCarDetail, setIsShownCarDetail] = useState(false);

  const newWifi = () => {
    newWifi(true);
  };
  const wifiHandler = () => {
    let nowUtc = moment.utc();
    let lastWiFiUtc = moment.utc(wifi);
    lastWiFiUtc.add(6, "minutes"); // six minute threshold based on 2/5 minutes for operational hours/not operational hours periodic status
    setIsWifi(nowUtc.isBefore(lastWiFiUtc));
  };
  useEffect(() => {
    wifiHandler();
  }, [wifi]);

  let batteryContent = <BatteryIcon color="#FA3C30" />;
  if (batteryLevel > 25) {
    batteryContent = <BatteryIcon color="#00A692" />;
  }
  if (batteryLevel > 10 && batteryLevel < 25) {
    batteryContent = <BatteryIcon color="#FFD707" />;
  }
  if (batteryLevel <= 10) {
    batteryContent = <BatteryIcon color="#FA3C30" />;
  }

  let carImage = BigCarImage;
  if (carType === 1) {
    carImage = FleetCarImage;
  }
  if (carType === 2) {
    carImage = MarshalCarImage;
  }
  if (carType === 3) {
    carImage = SpecialNeedCarImage;
  }
  if (carType === 4) {
    carImage = BewrageCarsImage;
  }
  if (carType === 5) {
    carImage = NotInUseCarImage;
  }
  if (carType === 6) {
    carImage = NotCommunicatingCarsImage;
  }

  const pace1 = inPace > 0;

  function renderCarIcon() {
    switch(carType)
    {
      case carType === 0:
        return <img src={SmallCarIcon} alt="car" className="list-view" />;
      case carType === 1:
        return <img src={SmallCarIcon} alt="car" className="list-view" />;
      case carType === 2:
        return <MarshalsCarIcon />;
      case carType === 3:
        return <SpecialNeedCarIcon  />;
      case carType === 4:
        return <FBIcon />;
      case carType === 5:
        return <img src={SmallCarIcon} alt="car" className="list-view" />;
      case carType === 6:
        return <img src={SmallCarIcon} alt="car" className="list-view" />;
      default:
        return <span className="card-view">No Icon</span>;
      }
  }
  
  const handleClick = () => {
    setIsShownCarDetail((current) => !current);
  };

  return (
    <CardWrapper
      className="list-view"
    >
      <CarSection
        style={{
          borderColor: `${pace1 ? "#999999" : "#FA3C30"}`,
          borderRight: "none",
        }}
        onClick={handleClick}
      >
        <h3>{carNo}</h3>
      </CarSection>
      <InfoSection>
        <div className="msg-section">
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {renderCarIcon()}
            <Tooltip title={t("Send_Message")} placement="top">
              <button
                onClick={(e) => {
                  setCarsData(e, carId, carNo);
                }}
              >
                <img src={ChatIcon} alt="chat-icon" />
                <span className="card-view">{t("Send_Message")}</span>
              </button>
            </Tooltip>
          </div>
          <div className="top-icon">
            <SignalIcon color={isWifi ? "#5AADFF" : "#636F7C"} />
            {charging ? <BatteryWithPowerIcon /> : batteryContent}
          </div>
        </div>
      </InfoSection>

      {isShownCarDetail && (
        <CarDetails
          carInformation={car}
          handleMapCarDetailClick={handleClick}
          closeWindowState={true}
          setIsShownCarDetail={setIsShownCarDetail}
        />
      )}
    </CardWrapper>
  );
};

export default CarInfoCard;
